import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class TranscriptValidationError extends EluveError {
  static override readonly errorName = 'TranscriptValidationError';
  readonly logLevel: LogLevel = 'warn';

  constructor(message = 'Transcript validation failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
